<template>
  <div>
    <TopContent />
    <div class="container">
      <router-view />
    </div>
    <FooterContent />
  </div>
</template>
<script>
import TopContent from './components/TopContent';
import FooterContent from './components/FooterContent';

export default {
  name: 'baseLayout',
  components: {
    TopContent,
    FooterContent,
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto 20px auto;
}

@media(min-width: 769px) and (max-width: 1200px) {
  .container {
    width: 1000px;
  }
}
</style>
